import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  IMAGE_BORDER_RADIUS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import Space from "../commons/Space";
import TextField from "@material-ui/core/TextField";
import FileHelper from "../../utils/FileHelper";
import {cloneDeep} from "lodash";
import SingleFilePicker, {
  ACCEPTED_IMAGE_MIMES, FILE_TYPE_IMAGE, FILE_TYPE_VIDEO,
  IMAGE_MAX_SIZE,
  IMAGE_MAX_WIDTH_HEIGHT,
} from "../commons/SingleFilePicker";
import {ColorActivityForm, ColorTheme} from "src/styles/Colors";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import FieldSpace from "src/js/components/commons/FieldSpace";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import {getInitialFiles} from "src/js/utils/ValueHelper";
import MediaPlaceholder from "src/js/components/commons/MediaPlaceholder";

const useStyles = (theme) => ({
  formActivityCTA: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: BORDER_RADIUS,
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityForm,
  },
  viewCTA: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
    paddingBottom: 0,
  },
  videoPreview: {
    borderRadius: BORDER_RADIUS,
    border: '5px solid '+ ColorTheme,
    marginLeft: 32,
    marginRight: 32,
    // marginBottom: 2 * FIELD_SPACE,
    width: 320,
    height: 640,
    [theme.breakpoints.down('md')]: {
      width: 280,
      height: 560,
    }
  },
  imageCustomise: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    padding: 8,
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityForm,
    minWidth: 260,
    width: '100%',
    marginBottom: 16
  },
  imageCustomisePlaceholderImage: {
    width: 48,
    height: 48,
    borderRadius: IMAGE_BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

class ManageActivityCTA1 extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;

    let cta1ImageUrl = null;
    if (activityData.sImageUrl) {
      cta1ImageUrl = activityData.sImageUrl;
    } else {
      cta1ImageUrl = activityData.business.imageUrl;
    }

    // const isSection2Expanded = activityData.s2LinkText || activityData.s2Link || activityData.s2ImageUrl || activityData.s2ImageFiles || activityData.videoUrl || activityData.videoFiles;
    // const isSection1Expanded = !isSection2Expanded || activityData.sName || activityData.sLink || activityData.sImageUrl || activityData.sImageFiles;
    const isSection2Expanded = false;
    const isSection1Expanded = true;
    this.state = {
      sections: [
        {id: 1, labelId: 'activity.manage.cta1Title', expand: isSection1Expanded, expandAlways: true},
        {id: 2, labelId: 'activity.manage.cta2Title', expand: isSection2Expanded},
      ],
      showValidationMsg: false,
      sName: activityData.sName,
      sLink: activityData.sLink,
      s2LinkText: activityData.s2LinkText,
      s2Link: activityData.s2Link,
      sImageUrl: cta1ImageUrl,
      sImageFiles: activityData.sImageFiles,
      isSImageDeleted: activityData.isSImageDeleted,
      s2ImageUrl: activityData.s2ImageUrl,
      s2ImageFiles: activityData.s2ImageFiles,
      isS2ImageDeleted: activityData.isS2ImageDeleted,
      videoUrl: activityData.videoUrl,
      videoFiles: activityData.videoFiles,
      isVideoDeleted: activityData.isVideoDeleted,
    };

    this.sImageInitialFiles = getInitialFiles(activityData.sImageFiles, cta1ImageUrl, FILE_TYPE_IMAGE);
    this.s2ImageInitialFiles = getInitialFiles(activityData.s2ImageFiles, activityData.s2ImageUrl, FILE_TYPE_IMAGE);
    this.initialVFiles = getInitialFiles(activityData.videoFiles, activityData.videoUrl, FILE_TYPE_VIDEO, activityData.videoTUrl);
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getData(excludeError) {
    const {activityData} = this.props;
    const {
      sName,
      sLink,
      sImageUrl,
      sImageFiles,
      isSImageDeleted,
    } = this.state;

    return {
      sName,
      sLink,
      sImageUrl,
      sImageFiles,
      isSImageDeleted,
    };
  }

  render() {
    const {
      sName,
      sLink,
    } = this.state;
    const {classes, isXS} = this.props;

    return (
      <div className={classes.viewColumnFullWidthNoCenter}>
        <div className={classes.formActivity}>
          {!this.props.hideSection ? <SectionHeaderView labelId={'activity.manage.cta1Image'} />
            : <MediaPlaceholder labelId={'activity.manage.cta1Image'} />
          }
          <Space top={2} />
          <SingleFilePicker
            key={'SFP1'}
            required={false}
            hideDropzoneText={true}
            size={isXS ? 'xsmall' : 'small'}
            filesLimit={1}
            showPreviewsInDropzone={true}
            acceptedFiles={ACCEPTED_IMAGE_MIMES}
            maxFileSize={IMAGE_MAX_SIZE}
            maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
            aspectRatio={1}
            initialFiles={this.sImageInitialFiles}
            onChange={(files) => {
              this.onChangeFiles(files, 'sImageUrl');
            }}
            onDelete={(file) => {
              this.onDeleteFile(file, 'sImageUrl');
            }}
          />
          <FieldSpace />

          <TextField
            variant="filled"
            fullWidth
            size="small"
            type="text"
            id="sName"
            name="sName"
            label={<FormattedMessage id='activity.manage.cta1Name'/>}
            InputProps={{disableUnderline: true}}
            inputProps={{maxLength: 10}}
            value={sName}
            onChange={this.onChange}
          />
          <FieldSpace />

          <TextField
            variant="filled"
            fullWidth
            size="small"
            type="text"
            id="sLink"
            name="sLink"
            label={<FormattedMessage id='activity.manage.cta1Link'/>}
            InputProps={{disableUnderline: true}}
            inputProps={{maxLength: 1000}}
            value={sLink}
            onChange={this.onChange}
            // helperText={<FormattedMessage id='activity.manage.hintCta1Link'/>}
          />
          <FieldSpace />
        </div>
      </div>
    )
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} onToggle={this.onFormSectionToggle} />
    );
  }

  onFormSectionToggle = (section) => {
    const {sections} = this.state;
    const index = sections.indexOf(section);
    const eSections = cloneDeep(sections);
    eSections[index].expand = !eSections[index].expand;
    this.setState({sections: eSections});
  }

  onChange = (event) => {
    let value = event.target.value;
    if (event.target.name === 'sLink' || event.target.name === 's2Link') {
      value = value.trim();
    }
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

  onChangeFiles(files, id) {
    const {
      sImageUrl,
      s2ImageUrl,
      videoUrl,
    } = this.state;

    let eImageUrl = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    if (id === 'sImageUrl') {
      eImageUrl = sImageUrl;
      keyImageUrl = 'sImageUrl';
      keyImageFiles = 'sImageFiles';
    } else if (id === 's2ImageUrl') {
      eImageUrl = s2ImageUrl;
      keyImageUrl = 's2ImageUrl';
      keyImageFiles = 's2ImageFiles';
    } else if (id === 'videoUrl') {
      eImageUrl = videoUrl;
      keyImageUrl = 'videoUrl';
      keyImageFiles = 'videoFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eImageUrl)) {
          lFileUrl = eImageUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.updateState({showValidationMsg: false, [keyImageUrl]: lFileUrl, [keyImageFiles]: lFiles});
  }

  onDeleteFile(file, id) {
    const {
      sImageUrl,
      sImageFiles,
      s2ImageUrl,
      s2ImageFiles,
      videoUrl,
      videoFiles,
    } = this.state;

    let eImageUrl = null;
    let eImageFiles = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    let keyIsImageDeleted = null;
    if (id === 'sImageUrl') {
      eImageUrl = sImageUrl;
      eImageFiles = sImageFiles;
      keyImageUrl = 'sImageUrl';
      keyImageFiles = 'sImageFiles';
      keyIsImageDeleted = 'isSImageDeleted';
    } else if (id === 's2ImageUrl') {
      eImageUrl = s2ImageUrl;
      eImageFiles = s2ImageFiles;
      keyImageUrl = 's2ImageUrl';
      keyImageFiles = 's2ImageFiles';
      keyIsImageDeleted = 'isS2ImageDeleted';
    } else if (id === 'videoUrl') {
      eImageUrl = videoUrl;
      eImageFiles = videoFiles;
      keyImageUrl = 'videoUrl';
      keyImageFiles = 'videoFiles';
      keyIsImageDeleted = 'isVideoDeleted';
    }

    let lFiles = [];
    let lFileUrl = eImageUrl;
    if (eImageFiles) {
      eImageFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
      });
      lFiles = eImageFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eImageUrl)) {
      lFileUrl = null;
    }

    this.updateState({showValidationMsg: false, [keyImageUrl]: lFileUrl, [keyImageFiles]: lFiles, [keyIsImageDeleted]: true});
  }

  onChecked = (event) => {
    const value = event.target.checked;
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

}

ManageActivityCTA1.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  user: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityCTA1.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
    user: state.admin.user,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityCTA1))
);
